import { render, staticRenderFns } from "./dir.vue?vue&type=template&id=89ae97aa&"
import script from "./dir.vue?vue&type=script&lang=js&"
export * from "./dir.vue?vue&type=script&lang=js&"
import style0 from "./dir.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports